import { useMemo } from 'react';

import { type IntlShape, useIntl } from 'react-intl-next';

import { useTimezoneOptions } from '@atlassian/eoc-schedule-common';

import { CreateVariant } from '../../../controllers/page-store/state/types';

import { messages } from './messages';
import { type FormFields, type UseDefaultValuesParams } from './types';

const generateName = (base: string, intlApi: IntlShape) => {
	return intlApi.formatMessage(messages.copyOf, { scheduleName: base });
};

const useDefaultValues = ({ variant, base }: UseDefaultValuesParams) => {
	const intlApi = useIntl();

	const { getTimezoneOption } = useTimezoneOptions();

	const defaults = useMemo((): FormFields => {
		switch (variant) {
			case CreateVariant.Create:
				return {
					name: '',
					description: '',
					timezone: getTimezoneOption(),
				};
			case CreateVariant.Clone:
				return {
					name: generateName(base!.name, intlApi),
					description: base!.description,
					timezone: getTimezoneOption({ timeZone: base!.timezone }),
				};
		}
	}, [base, getTimezoneOption, intlApi, variant]);

	return defaults;
};

export { useDefaultValues };
